module.exports = __webpack_public_path__ + "img/ic_insights_opened.fb4e16f2.png";